<!------------- ETC comments threads pops up ------------------>
	<div class="reject_popup" *ngIf="thread_msg !== null">
		<div class="reject_popup_wrapper">
			<div class="reject_popup_header">
				<h3>{{"RejectReason" | translate}}</h3><button class="pop_close" (click)="threadClose()"><i class="bi bi-x"></i></button>
			</div>
			<div class="reject_popup_body" *ngIf="thread_msg.length > 0; else noMsg">
				<ul>
					<li *ngFor="let msg of thread_msg" class="client asso">
						<h5>{{msg.modifyUserName}}<span>{{formatDateTime(msg.modifyDate)}}</span></h5>
						<p>{{msg.modifyComment}}</p>
					</li>
				</ul>
			</div>
			<ng-template #noMsg>
				<div class="reject_popup_body">
					<p>{{'NoComments' | translate}}</p>
				</div>

			</ng-template>
		
		</div>
		
	</div>

<!---------------------------- END ----------------------------->


<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			[(ngModel)]="selectedTimesheetId"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.timesheetId">
					{{ "DDMONTH."+getMonth(date.weekEnding) | translate}} {{getYear(date.weekEnding)}} ({{date.companyName}})
				</option>
			</select>
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{timeSheetCmnData?.customerName}}</p>
		</div><!-- {{userCode}} -->
		<div class="summary col-auto">
			<h2>{{"MonthlySummary" | translate}} :</h2>
			<ul>
				<li>
					<p><strong>{{"REGULAR" | translate}} - </strong> <span>{{timeSheetTopPannel?.regular}}</span></p>
				</li>
				<li>
					<p><strong>{{"OVERTIME" | translate}} - </strong> <span>{{timeSheetTopPannel?.overtime}}</span></p>
				</li>
				<li>
					<p><strong>{{"MIDNIGHT" | translate}} - </strong> <span>{{timeSheetTopPannel?.midnightOvertime}}</span></p>
				</li>
				<li>
					<p><strong>{{"TOTAL" | translate}} - </strong> <span>{{timeSheetTopPannel?.total}}</span></p>
				</li>
			</ul>
		</div>
		</section>
</div>

<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">

	<div class="actio_button_area">
		<div class="asso_name">
			<strong>{{'Associate' | translate}} : </strong>{{timeSheetTopPannel?.userName}}
		</div>
		<!-- <button class="butn save_entry btn" (click)="onSave()">{{"SAVE" | translate}}</button> -->
		<!--<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>-->
		<!-- <button class="butn log_entry btn">{{"LOG" | translate}}</button> 
		 <a class="butn log_entry btn" href="associate-time-log/{{timesheetIdOrg}}">{{"LOG" | translate}}</a>-->
		<a href="manager-resource-timesheet/{{timesheetIdOrg}}/{{userIdOrg}}" class="butn as_resource btn">{{"Resource" | translate}}</a>
		<a href="manager-approver-timesheet/{{timesheetIdOrg}}/{{userIdOrg}}" class="butn as_approver btn">{{"Approver" | translate}}</a>
		<a class="butn pdf_down btn" href="javascript:void(0)" (click)="dwnPdf(timesheetId)">{{"PDFDWN" | translate}}</a>
	</div>
	<div *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
            {{ dashboard_msg | translate}}
			  
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
	<div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<!--<li class="fix"><s>F</s><span>Fix</span></li>-->
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
		
	</div>
	<!--  ############### Data Table Start ################# -->
	<!-- ############# Data table for Manager ################-->
	<div class="time_sheet_table_wrapper">
		<!-- Table Heading Start -->
		<div class="timeSheet_row_heading timesheet-header">
			
            <section>
                <article>
                    <div class="tbl_date">{{"DATE" | translate}}</div>
                    <div class="tbl_approve">
                        <!-- <label class="switch">
							<input type="checkbox"
							[(ngModel)]="selectAll"
								[ngModelOptions]="{standalone: true}"
								(change)="toggleAllApprovals($event)">
							<span class="slider"></span>
						</label> -->
                        {{"Delete" | translate}}
                    </div>
                    <div class="tbl_status">{{"STATUS" | translate}}</div>
                    <div class="tbl_action">{{"SendBack" | translate}}</div>
                	<div class="tbl_start">{{"START" | translate}}</div>
                    <div class="tbl_finish">{{"FINISH" | translate}}</div>
                    <div class="tbl_break">{{"BREAK" | translate}}</div>
                    <div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
                    <div class="tbl_note">{{"NOTE" | translate}}</div>
                    <div class="tbl_home">{{"HOME" | translate}}</div>
                    <div class="tbl_exp">{{"EXPENSES" | translate}}</div>
                    <div class="tbl_amtExp">{{"AMOUNTOFEXPENSES" | translate}}</div>
                    <div class="tbl_etc">{{"ETC" | translate}}</div>
                </article>
            </section>
        </div>
		<!-- Table Heading End -->
		<!-- Table Data Start as loop-->

		<div class="timeSheet_row {{getClass(item.status)}}" *ngFor="let item of timeSheetData; let i = index">
            <section>
                <aside>
                    <div class="tbl_nav">
						<button class="expand" [class.active]="expandedRowsButton[i]" (click)="toggleBelowRows(i)"></button>
					</div>
					<div class="tbl_date">
						<strong class="{{getDayWeekKey(item.dayDate).shortweekday}} {{item.isHoliday? 'sun':''}}">{{ getDayWeekKey(item.dayDate).day }} {{ getDayWeekKey(item.dayDate).weekdayKey | translate }}</strong>
					</div>
					<div class="tbl_status">
						<dl><span [ngClass]="{ 'get_comment': (item.status === 30 || item.status === 20) }" (click)="onRejectClick(item)">{{ getStatus(item.status).statusKey | translate }}</span></dl>
					</div>
					<div class="tbl_start">
						<p>{{item.startTime}}</p>
                    </div>
                    <div class="tbl_finish">
						<p>{{item.endTime}}</p>
                    </div>
                    <div class="tbl_break">
						<p>{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <p>{{item.midnightBreakMinutes}}</p>
                    </div>
                </aside>
                <article [ngClass]="{ 'expanded': expandedRows[i] }">
					<div class="tbl_date">
						<strong class="{{getDayWeekKey(item.dayDate).shortweekday}} {{item.isHoliday? 'sun':''}}">{{ getDayWeekKey(item.dayDate).day }} {{ getDayWeekKey(item.dayDate).weekdayKey | translate }}</strong>
					</div>
                    <div class="tbl_approve">
						<samp></samp>
                        <!-- <label class="switch" *ngIf="(item.status == 20)">
							<input type="checkbox" 
							[(ngModel)]="item.markedForSubmit" 
							[ngModelOptions]="{standalone: true}" class="chkApproveStatus" />
							<span class="slider"></span>
						</label> -->
                    </div>
                    <div class="tbl_status">
						<samp>{{"STATUS" | translate}}</samp>
						<dl><span [ngClass]="{ 'get_comment': (item.status === 30 || item.status === 20) }" (click)="onRejectClick(item)">{{ getStatus(item.status).statusKey | translate }}</span></dl>
					</div>
                    <div class="tbl_action">
						<samp>{{"EDIT" | translate}}</samp>
                        <div class="reject_save" *ngIf="(item.status == 40)">
                            <!-- <label class="switch">
								<input type="checkbox" 
								[(ngModel)]="item.markedForReject" 
								[ngModelOptions]="{standalone: true}" class="chkStatus" (change)="editReject(i)" />
								<span class="slider"></span>
							</label>
							<button name="cancel" class="cancel" (click)="cancelReject(i)" *ngIf="editingRow === i" title="{{'CANCEL' | translate}}">cancel</button>
							<button name="save" class="save" (click)="saveReject(i)" *ngIf="editingRow === i" title="{{'SAVE' | translate}}">save</button> -->
							<button name="back" class="back" (click)="sendBack(i)">{{"SendBack" | translate}}</button>
						</div>    
                    </div>
                    <div class="tbl_start">
                        <samp>{{"START" | translate}}</samp>
						<p>{{item.startTime}}</p>
                    </div>
                    <div class="tbl_finish">
                        <samp>{{"FINISH" | translate}}</samp>						

						<p>{{item.endTime}}</p>
                    </div>
                    <div class="tbl_break">
                        <samp>{{"BREAK" | translate}}</samp>
                        
						<p>{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <samp>{{"MIDNIGHTBREAK" | translate}}</samp>
                        <p>{{item.midnightBreakMinutes}}</p>
                    </div>
                    <div class="tbl_note">
                        <samp>{{"NOTE" | translate}}</samp>                        
						<p>{{getNote(item.noteId).noteKey | translate}}</p>
                    </div>
                    <div class="tbl_home">
                        <samp>{{"HOME" | translate}}</samp>
                        <label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" [ngModelOptions]="{standalone: true}" disabled="">
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_exp">
                        <samp>{{"EXPENSES" | translate}}</samp>                        
						<p>{{getExpenses(item.expenseId).expensesKey | translate}}</p>
                    </div>
                    <div class="tbl_amtExp">
                        <samp>{{"AMOUNTOFEXPENSES" | translate}}</samp>
                        <p>{{item.cost}}</p>
                    </div>
                    <div class="tbl_etc">
                        <samp>{{"ETC" | translate}}</samp>
						<!-- <input type="text"  /> -->
						
						<p *ngIf="editingRow !== i" 
						class="info" 
						data-bs-toggle="tooltip" 
						data-bs-placement="top" 
						[attr.title]="item.etcRemarks || 'No remark'"
  						#tooltipEl>{{getShortText(item.etcRemarks, 25)}}</p>
                    </div>
					<address *ngIf="editingRow === i" >
						<samp>{{"ETC" | translate}}</samp>
						<textarea name="etc" id="etc" class="form-control" [(ngModel)]="item.etcRemarks" rows="1"></textarea>
					</address>
                </article>
            </section>
        </div>
		

		<!-- Table Heading End as loop -->
	</div>
	
	<!--  ############### Data Table End ################# -->
	<div class="work_hour_info">
		<h6>{{"Contract" | translate}} -</h6>
		<span *ngIf="jobOrderData">{{"START" | translate}} {{ toTimeString(jobOrderData.WorkStartTime) }}</span><span *ngIf="jobOrderData">{{"FINISH" | translate}} {{ toTimeString(jobOrderData.WorkEndTime) }}</span><span *ngIf="jobOrderData">{{"BREAK" | translate}} {{jobOrderData.breakTime}}</span><span *ngIf="jobOrderData">{{"MIDNIGHTBREAK" | translate}} {{jobOrderData.midBreakTime}}</span>
	</div>
	<div class="training_entry_box mt-3" *ngIf="historyCommentsDis !== ''">
		<h4>{{"ClienttimeSheet.ClaimHistory" | translate}}  
			<!-- {{"ClienttimeSheet.Claimeddate" | translate}}: {{formatClaimDate(timeSheetCmnData.complaintCmtUpdateDate)}} -->
		</h4>
		<p style="white-space: pre-line;">{{historyCommentsDis}}</p>
	</div>
	<div class="training_entry_box mt-3" *ngIf="trainingCommentsDis !== ''">
		<h4>{{"ClienttimeSheet.TrainingHistory" | translate}}</h4>
		<p style="white-space: pre-line;">{{trainingCommentsDis}}</p>
	</div>
	
	<div class="actio_button_area">
		<button class="butn claim_history btn" data-bs-toggle="modal" data-bs-target="#claim_history_popup">{{"ClienttimeSheet.ClaimHistory" | translate}}</button>
		<button class="butn training_history btn" data-bs-toggle="modal" data-bs-target="#training_history_popup">{{"ClienttimeSheet.TrainingHistory" | translate}}</button>
		<button class="butn training_history btn" data-bs-toggle="modal" data-bs-target="#order_comments_popup">{{"ClienttimeSheet.OrderRelatedComments" | translate}}</button>
	</div>
</div>

<!-- Modal for claim_history Start-->
	<!-- Modal for claim_history Start-->
	<div class="modal fade" id="claim_history_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.ClaimHistory" | translate}} </h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<!-- <div class="sub_header_block">
					<div class="col-auto">
						<label class="col-form-label">{{"ClienttimeSheet.Claimeddate" | translate}}:</label>
					</div>
					<div class="col-auto">
						<select class="form-select" aria-label="Default select example" [(ngModel)]="selectedYear">
							<option *ngFor="let year of yearList" value="{{year}}">{{year}}</option>
						</select>
					</div>
					<div class="col-auto">
						<select class="form-select" aria-label="Default select example" [(ngModel)]="selectedMonth">
							<option *ngFor="let num of monthList" value="{{num}}">{{num}}</option>
						</select>
					</div>
					<div class="col-auto">
						<select class="form-select" aria-label="Default select example" [(ngModel)]="selectedDay">
							<option *ngFor="let day of dayList" value="{{day}}">{{day}}</option>
						</select>
					</div>
				</div> -->
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="historyComments"></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btnclaim_history_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btnclaim_history_popup">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveHistory()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for claim_history End-->
	<!-- Modal for claim_history End-->

	<!-- Modal for training_history Start-->
	<div class="modal fade" id="training_history_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.TrainingHistory" | translate}}</h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="sub_header_block">
					<div class="col-auto">
						{{"TrainingHistoryHeading" | translate}}
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="trainingComments" ></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btntraining_history_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btntraining_history_popup">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveTraining()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for training_history End-->
	 
	<!-- Modal for Orde comments Start-->
	<div class="modal fade" id="order_comments_popup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">{{"ClienttimeSheet.OrderRelatedComments" | translate}}</h3>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<!-- <div class="sub_header_block">
					<div class="col-auto">
						「実施年月日」「時間数 (xx時間) 」「訓練内容」をご記入ください
					</div>
				</div> -->
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12">
							<textarea name="" id="" class="form-control" rows="3" placeholder="{{'TrainingCmntPlaceHolder' | translate}}" [(ngModel)]="orderComments" ></textarea>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button #btnorder_comments_popup type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btnorder_comments_popup">{{"CLOSEBTN" | translate}}</button>
					<button type="button" class="btn btn-primary" (click)="saveOrderComment()">{{"SAVE" | translate}}</button>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for order comments End-->
<!--  ############### Middle Containt Area End ################# -->